module.exports = __webpack_public_path__ + "img/24.0bdf6ca1.jpg";